import React from "react";

const Contact = () => {
  return (
    <div name="contact" className=" h-screen pt-16">
      <h1 className="md:text-6xl text-3xl text-center mb-4 md:mb-20 font-rubik  font-bold text-[#FC5130]">
        Get in Touch
      </h1>
      <div className=" text-[#bcbbbb] text-center lg:flex lg:flex-row flex flex-col">
        <div className="max-w-2xl my-auto  mx-auto">
          <p className="font-poppins font-extralight md:p-0 px-8 pb-2  md:text-4xl text-xl text-[#e5e5e5]">
            Hey! <br />
            My inbox is always open. Whether you have a question or just want to
            say hi, I will definitely get back to you! If you want to hire me or
            are curious about my work, feel free to contact me.
            <br />
            I'll be sure to reply.
          </p>
        </div>

        <div className="container  lg:w-[40%]">
          <form
            action="https://getform.io/f/0e6b6217-185e-42dc-ad70-223af268a6f5"
            method="POST"
            className="flex flex-col py-4 justify-center mx-auto  w-[70%] h-full"
          >
            <input
              type="text"
              name="Name"
              placeholder="Name"
              className="bg-transparent p-2 border-2 border-white focus:outline-none"
              required
            />
            <input
              type="email"
              name="Email"
              placeholder="Email"
              className="my-4 bg-transparent p-2 border-2 border-white focus:outline-none"
              required
            />
            <textarea
              name="Message"
              rows="10"
              placeholder="Message"
              className="bg-transparent p-2 border-2 border-white focus:outline-none"
              required
            ></textarea>
            <button className="font-comfortaa font-bold hover:bg-transparent hover:text-white hover:border-white border-black border-2 bg-white text-black mt-12 mx-auto lg:w-[40%] p-4 rounded-md">
              Contact me
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
